/**
 * save-subject-context-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Todd L Smith <tsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

/**
 * A client transmits a {@link SaveSubjectContextRequest} to write a subject
 * context to the database. The subject context must be already known to the
 * client through an opaque contextual reference.
 */
export class SaveSubjectContextRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_SAVE_SUBJECT_CONTEXT;
	public static tag : MessageTag = MessageTag.REQ_SAVE_SUBJECT_CONTEXT;

  /**
   * Construct a new {@link SaveSubjectContextRequest}.
   */
  constructor (
    public objectId : number,
    public saveForcibly : boolean = false
  )
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/context-management/save-subject-context-request.ts